import React from "react"
import { Button } from "react-bootstrap"
import { FaUserSlash } from "react-icons/fa"
import { useAuth0 } from "@auth0/auth0-react"

const LogoutButton = () => {
	let logoutFn = null
	try {
		const auth = useAuth0()
		logoutFn = auth?.logout
	} catch (e) {}

	const handleLogout = () => {
		if (logoutFn) {
			logoutFn({ returnTo: window.location.origin })
		} else {
			window.location.href = "/"
		}
	}

	return (
		<div className="position-fixed top-0 end-0 m-3" style={{ zIndex: 1100 }}>
			<Button type="button" className="btn btn-danger shadow-sm" variant="primary" onClick={handleLogout} title="Sair do Admin">
				<FaUserSlash /> Sair
			</Button>
		</div>
	)
}

export default LogoutButton
